// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"fadfc5ce","610":"da4b7fb8","988":"80ef7ac6"}[chunkId] + ".chunk.js";
};